import { useCallback, useEffect, useState } from "react";
import { Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { UploadDialog } from "@/components/UploadDialog";
import { MaterialRow } from "@/components/MaterialRow";
import { api } from "@/lib/api";
import { coinLabel } from "@/lib/constants";

export default function MyFilesPage() {
  const { user, refreshMe } = useAuth();
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    api.get("/materials/mine").then((r) => setItems(r.data)).catch(() => setItems([]));
    refreshMe();
  }, [refreshMe]);
  useEffect(() => { load(); }, [load]);
  const n = (st) => (items || []).filter((m) => m.status === st).length;

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 rise">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[#0b2e20]">Мои файлы</h1>
          <p className="text-[#4b6b5c] mt-3">За каждый одобренный файл — 50 коинов.</p>
        </div>
        <UploadDialog onUploaded={load} />
      </div>
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="col-span-2 sm:col-span-1 rounded-2xl bg-[#0b2e20] text-white p-5 grain">
          <div className="text-xs uppercase tracking-widest text-[#a3e6be] font-bold">Баланс</div>
          <div className="font-display text-3xl font-extrabold mt-2 flex items-center gap-2" data-testid="my-coins-balance"><Coins className="h-6 w-6 text-amber-400" />{coinLabel(user)}</div>
        </div>
        {[["approved", "Одобрено"], ["pending", "На проверке"], ["rejected", "Отклонено"]].map(([k, l]) => (
          <div key={k} className="rounded-2xl bg-white border border-[#d1e7dd] p-5">
            <div className="text-xs uppercase tracking-widest text-[#2e7d56] font-bold">{l}</div>
            <div className="font-display text-3xl font-extrabold mt-2 text-[#0b2e20]" data-testid={`my-files-count-${k}`}>{n(k)}</div>
          </div>
        ))}
      </div>
      <div className="mt-8 space-y-3" data-testid="my-files-list">
        {items && items.length === 0 && <p className="text-sm text-[#6b8a7b] py-10 text-center" data-testid="my-files-empty">Вы ещё не загружали файлы</p>}
        {(items || []).map((m) => <MaterialRow key={m.id} m={m} showStatus showSubject />)}
      </div>
    </div>
  );
}
